export default __webpack_public_path__ + "static/media/webDeveloper.25c28757.png";